<template>
  <section class="container d-flex flex-column mt-3">
    <header>
      <span class="h6">
        <router-link to="/">Início</router-link>
        / Raças
      </span>

      <h3 class="text-center my-5">Raças</h3>
    </header>

    <section v-for="race in races" :key="race.name" class="mb-5">
      <div
        class="d-flex flex-column flex-md-row justify-content-center align-items-center bg-white"
      >
        <img :src="race.img" :alt="race.name" style="max-height: 200px;" />
        <h4 class="text-uppercase mb-3" style="color: #444;">
          {{ race.name }}
        </h4>
      </div>

      <table id="char_table" class="table table-dark table-striped">
        <tbody>
          <tr>
            <td colspan="2" class="text-center">
              <span class="text-uppercase mr-2">PV:</span>
              {{ race.pv }}
            </td>
            <td colspan="2" class="text-center">
              <span class="text-uppercase mr-2">PH:</span>
              {{ race.ph }}
            </td>
            <td colspan="2" class="text-center">
              <span class="text-uppercase mr-2">Mov:</span>
              {{ race.mov }}
            </td>
          </tr>

          <tr>
            <td colspan="3" class="text-center">
              <span class="text-uppercase mr-2">
                {{ getAttributeLabel('str') }}
              </span>
              {{ race.str }}
            </td>
            <td colspan="3" class="text-center">
              <span class="text-uppercase mr-2">
                {{ getAttributeLabel('res') }}
              </span>
              {{ race.res }}
            </td>
          </tr>

          <tr>
            <td colspan="3" class="text-center">
              <span class="text-uppercase mr-2">
                {{ getAttributeLabel('dex') }}
              </span>
              {{ race.dex }}
            </td>
            <td colspan="3" class="text-center">
              <span class="text-uppercase mr-2">
                {{ getAttributeLabel('agi') }}
              </span>
              {{ race.agi }}
            </td>
          </tr>

          <tr>
            <td colspan="3" class="text-center">
              <span class="text-uppercase mr-2">
                {{ getAttributeLabel('wis') }}
              </span>
              {{ race.wis }}
            </td>
            <td colspan="3" class="text-center">
              <span class="text-uppercase mr-2">
                {{ getAttributeLabel('int') }}
              </span>
              {{ race.int }}
            </td>
          </tr>

          <tr>
            <td class="text-center text-uppercase font-weight-bold" colspan="6">
              Habilidades
            </td>
          </tr>

          <tr v-for="(skill, index) in race.skills" :key="skill.name">
            <td colspan="6">
              <span class="text-uppercase mr-2"
                >{{ getSkillLevelLabel(index) }}:</span
              >
              {{ skill.name }} ({{ getSkillTypeLabel(skill.type) }})
              <br />
              <small>{{ skill.desc }}</small>
            </td>
          </tr>

          <template v-if="race.special">
            <tr>
              <td
                class="text-center text-uppercase font-weight-bold"
                colspan="6"
              >
                Habilidade Especial ({{
                  getSkillLevelLabel(race.special.value - 1)
                }}+)
              </td>
            </tr>

            <tr>
              <td colspan="6">
                {{ race.special.name }} ({{
                  getSkillTypeLabel(race.special.type)
                }})
                <br />
                <small>{{ race.special.desc }}</small>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </section>
  </section>
</template>

<script>
import { races } from '../data/races'
import {
  getAttributeLabel,
  getSkillTypeLabel,
  getSkillLevelLabel
} from '../utils/texts'

export default {
  name: 'races',

  data: () => ({
    races: races.sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    )
  }),

  methods: {
    getAttributeLabel,
    getSkillTypeLabel,
    getSkillLevelLabel
  }
}
</script>
